import React, { useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { apiPost } from '../../../utils/api'; // 공통 API 함수
import '../../../css/Member/Login/loginForm.css';

// 로그인 폼: 이메일/비밀번호를 입력받아 서버에 로그인 요청을 보낸다.
function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState({ email: '', password: '' });

  // ADDED: 포커스 상태를 추적할 state 변수
  const [isEmailFocused, setIsEmailFocused] = useState(false);
  const [isPasswordFocused, setIsPasswordFocused] = useState(false);

  // 로그인 요청을 호출하고 결과에 따라 메시지와 리다이렉션을 처리한다.
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError({ email: '', password: '' });

    try {
      const res = await apiPost('/member/login.php', {
        email,
        password,
      });

      if (res.result === 'success' && res.code === 200) {
        // console.log('Login successful:', res.data);

        // 아이디 저장 기능
        if (remember) {
          localStorage.setItem('savedEmail', email);
        } else {
          localStorage.removeItem('savedEmail');
        }

        const params = new URLSearchParams(window.location.search);
        const redirectUrl = params.get('redirect');
        window.location.href = redirectUrl || '/';
      } else if (res.result === 'error') {
        if (res.code === 404) {
          setError({ email: res.reason, password: '' });
        } else if (res.code === 401) {
          setError({ email: '', password: res.reason });
        } else if (res.code === 403) {
          setError({ email: res.reason, password: '' });
        } else {
          alert(res.reason || '로그인 중 오류가 발생했습니다.');
        }
      }
    } catch (err) {
      console.error('Login request failed', err);
      alert('서버와 통신 중 문제가 발생했습니다.');
    }
  };

  // 비밀번호 입력창 아이콘 클릭 시 텍스트/패스워드 모드를 토글한다.
  const togglePasswordVisibility = () => {
    setPasswordVisible(prev => !prev);
  };

  return (
    <div className="login-container">
      <h2 className='login-title'>로그인</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <label htmlFor="email" className="input-label">아이디(이메일 주소)<span>*</span></label>
        <input
          type="email"
          id="email"
          placeholder="이메일 주소를 입력해 주세요"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onFocus={() => setIsEmailFocused(true)} // ADDED
          onBlur={() => setIsEmailFocused(false)}  // ADDED
          className={`login-input ${isEmailFocused ? 'is-focused' : ''} ${error.email ? 'is-error' : ''}`} // MODIFIED
          required
        />
        {error.email && <div className="input-error">{error.email}</div>}

        <label htmlFor="password" className="input-label">비밀번호<span>*</span></label>
        <div className="password-input-wrapper">
          <input
            type={passwordVisible ? 'text' : 'password'}
            id="password"
            placeholder="비밀번호를 입력해 주세요."
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onFocus={() => setIsPasswordFocused(true)} // ADDED
            onBlur={() => setIsPasswordFocused(false)}  // ADDED
            className={`login-input password-input ${isPasswordFocused ? 'is-focused' : ''} ${error.password ? 'is-error' : ''}`} // MODIFIED
            required
          />
          <span className="password-eye-icon" onClick={togglePasswordVisibility}>
            {passwordVisible ? <FaRegEyeSlash /> : <FaRegEye />}
          </span>
        </div>
        {error.password && <div className="input-error">{error.password}</div>}

        <div className="checkbox-container">
          <div className="remember-container">
            <input
              type="checkbox"
              id="remember"
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
            <label htmlFor="remember" className="checkbox-label">아이디 저장</label>
          </div>
          <a href="/forgot-password" className="forgot-password">비밀번호 찾기</a>
        </div>

        <button type="submit" className="login-button">로그인 하기</button>
        <div className="register-prompt">
          아이디가 없으신가요? <a href="/register">회원가입하기</a>
        </div>
      </form>
    </div>
  );
}

export default LoginForm;
